import React, {useEffect, useState} from 'react'
import Navbar from '../components/Navbar'
import '../assets/css/dashboard.css'
import { useHistory, Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faCheckCircle, faCreditCard, 
    faEye, faLandmark, 
    faPencilAlt, faShieldAlt, faSpinner, faTrashAlt, faUserCircle
} from '@fortawesome/free-solid-svg-icons'

import { Greet, ShowWalletAdress, Status } from '../components/DashboardComponent'
import UploadId from '../components/modals/UploadID'
import Deposit from '../components/modals/DepositToWallets'
import AddCard from '../components/modals/AddCard'
import AddBank from '../components/modals/AddBank'
import ViewBank from '../components/modals/ViewBank'
import ViewCard from '../components/modals/ViewCard'
import EditCard from '../components/modals/EditCard'
import EditBank from '../components/modals/EditBank'
import DeleteCard from '../components/modals/DeleteCard'
import DeleteBank from '../components/modals/DeleteBank'
import { getUser } from '../utils/profile';

const Profile = () => {
    const history = useHistory()
    if (!sessionStorage.getItem('idToken')) {
        history.push('/signin')
    }

    const [profile, setProfile] = useState(null)
    const [, setIsPending] = useState(false)
    const [, setError] = useState(null)

    const verifyStatus = {
        upload: true,
        bank: false,
        deposit: false,
    }
    const percentStatus = () => {
        let upload = verifyStatus.upload? 1: 0
        let bank = verifyStatus.bank?1:0
        let deposit=verifyStatus.deposit?1:0
        return Math.floor((upload+bank+deposit)/3*100)
    }
    useEffect(() => {
        document.title = 'Pouch | Profile'
        const fetchUser = async () => {
            setIsPending(true)
            let user = await getUser(sessionStorage.getItem('localId'))
            console.log(user)
            if (!user) {
              setError('Could not fetch user data')
            } else {
              if(user.code === 400) {
                setError(user.message || 'Could not fetch user data')
              } else {
                setProfile(user)
              }
            }
        }
        fetchUser()
        setIsPending(false)
        console.log(profile)
        // eslint-disable-next-line
    }, [])
    console.log(profile)
    return (
        <>
            <Navbar />
            {profile ? <div className="container p-2">
                {/* Profile hero */}
                <div className="py-3" style={{borderRadius: '15px'}}>
                    <div className="row mx-0">
                        <Greet />
                    </div>
                    <div className="row d-flex justify-content-around mx-2 my-2 dash-card bg-1 text-white">
                        <div className="col-md p-3 h6 display-6">
                            <div className="row">
                                <div className="col">
                                    <h6 className="">
                                        <FontAwesomeIcon icon={faUserCircle} /> {profile.email.stringValue} 
                                        <span className="text-warning h6 small" style={{whiteSpace : 'nowrap'}}>
                                            <FontAwesomeIcon icon={faCheckCircle}  className="ml-md-2"/> Verified
                                        </span>
                                    </h6>
                                    <ShowWalletAdress />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5 p-3">
                            <h6 className="border-bottom"><b>Profile Completion</b></h6>
                            <p className="m-0">
                                <div className="w-75 float-right mt-2 p-1" style={{background : '#ccc', borderRadius : '30px'}}>
                                    <div className="bg-success p-2" style={{width: `${percentStatus()}%`, borderRadius : '30px'}}></div>
                                </div>
                                <span className="h3">{percentStatus()}%</span>
                            </p>
                            <div className="w-100">
                                <div className="text-muted m-1 p-2" style={{maxWidth: '100%', overflowY: 'auto', whiteSpace : 'nowrap'}}>             
                                    <Status 
                                        Modal={<UploadId  title="Upload your NID" />}
                                        id="modalUploadID"
                                        title="Upload ID" 
                                        status={verifyStatus.upload? "success": "danger" }
                                        description="You uploaded NID"/>
                                    <Status 
                                        Modal={<AddBank />} 
                                        id="modalAddBank"
                                        title="Connect Bank Account" 
                                        status={verifyStatus.bank? "success": "danger" } 
                                        description="Connect Your bank accounts"/>
                                    <Status 
                                        Modal={<Deposit  title="Deposit Money" />} 
                                        id="modalDepositToWallets"
                                        title="Deposit Money"
                                        status={verifyStatus.deposit? "success": "danger" } 
                                        description="You can deposit from your bank"/>
                                    
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>

                <div className="container mt-4 py-2">
                    <h5>Account Verification</h5>
                    <hr className="bg-purple" />
                    <div className="row">
                        <div className="col-md shadow m-1 py-3">
                            <h6 className="text-left">Identity Verification</h6>
                            <div className="container btn-outline-purple text-center p-3 py-5" style={{ borderRadius: '20px'}}>
                                <p>
                                    <button className="btn bg-success text-white px-3 py-2 pt-3 rounded-circle">
                                        <FontAwesomeIcon icon={faShieldAlt} className="h4" />
                                    </button>
                                </p>
                                <p>
                                    <h5>Please verify your identity before adding your debit card</h5>
                                    <h6>Uploading your ID helps as ensure the safety and security of your founds</h6>
                                </p>
                                <button type="button" data-toggle="modal" data-target="#modalUploadID" className="btn btn-success round-button" >Upload ID</button>
                                <UploadId title="Upload your ID" />
                            </div>
                        </div>
                        <div className="col-md shadow m-1 py-3">
                            <h6 className="text-left">Linked Accounts</h6>
                            <div style={{maxHeight: '270px', overflowY: 'auto', width: '100%', overflowX: 'hidden'}}>
                                    {[
                                        {
                                            id: 1,
                                            type: 'Credit Card',
                                            name: 'GTB Master Card',
                                            value: "5490 3843 9564"
                                        },
                                        {
                                            id: 2,
                                            type: 'Debit Card',
                                            name: 'Firstbank Verve',
                                            value: "94980 38430 95644"
                                        },
                                        {
                                            id: 3,
                                            type: 'Bank',
                                            name: 'GT Bank',
                                            value: "0869948493"
                                        }
                                    ].map(item => <BankorCard 
                                                    key={item.id} 
                                                    type={item.type} 
                                                    name={item.name} 
                                                    value={item.value} />)
                                    }
                            </div>
                            <p className="d-flex justify-content-between mt-3">                                
                                <button className="btn btn-primary round-button" type="button" data-toggle="modal" data-target="#modalAddBank">Add Bank Account</button>
                                <button className="btn btn-success round-button" type="button" data-toggle="modal" data-target="#modalAddCard">Add Debit Card</button>
                                <AddCard />
                            </p>
                        </div>
                    </div>
                </div>
            </div> :
                <p className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh'}}>                    
                    <FontAwesomeIcon icon={faSpinner} spin className="h3 display-4" />
                </p>
            }
            <ViewBank />
            <ViewCard />
            <EditBank />
            <EditCard />
            <DeleteBank />
            <DeleteCard />
        </>
    )
}
const BankorCard = ({type, name, value}) => {
    for (let i = 0; i < value.length - 4; i++) {
        value = value.replace(value[i], '*');
    }
    return (
        <div className="row py-3 my-2 rounded">
            <div className="col-3 col-lg-2">
                <button className="btn bg-purple px-3 py-2 pt-3 rounded-circle">
                    {type === 'Credit Card' || type === 'Debit Card'? 
                        <FontAwesomeIcon icon={faCreditCard} className="h4" />
                        :
                        <FontAwesomeIcon icon={faLandmark} className="h4" />
                    }
                </button>
            </div>
            <div className="col">
                <h5 className="text-purple">{name}</h5>
                <p className="text-secondary m-0">{type} {value}</p>
            </div>
            <div className="col-2 col-lg-4">
                <div className="row">
                    <div className="col-md">
                        <Link 
                            to="#" type="button" 
                            data-toggle="modal" 
                            data-target={type === "Bank"? "#modalViewBank" : "#modalViewCard"} 
                        ><FontAwesomeIcon icon={faEye} className="text-purple" /></Link>
                    </div>
                    <div className="col-md">                                            
                        <Link 
                            to="#" type="button" 
                            data-toggle="modal" 
                            data-target={type === "Bank"? "#modalEditBank": "#modalEditCard"} 
                        ><FontAwesomeIcon icon={faPencilAlt} className="text-purple" /></Link>
                    </div>
                    <div className="col-md">                                            
                        <Link 
                            to="#" type="button" 
                            data-toggle="modal" 
                            data-target={type === "Bank"? "#modalDeleteBank": "#modalDeleteCard"} 
                        ><FontAwesomeIcon icon={faTrashAlt} className="text-danger" /></Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Profile